import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IResponseEvents } from '../interfaces/IEvents';

@Injectable({
  providedIn: 'root',
})
export class EventsApiService {
  public currentDate: Date = new Date();
  private readonly population: string =
    '&populate[image][populate]=*&populate[live_image][populate]=*&populate[photosEvent][populate]=*&populate[meta][populate]=*&populate[event_authors][populate]=*';

  constructor(private http: HttpClient) {}

  public getEvents(): Observable<IResponseEvents> {
    return this.http.get<IResponseEvents>(`@cms/events?sort[0]=dateStart:desc${this.population}`);
  }

  public getActiveEvents(): Observable<IResponseEvents> {
    return this.http.get<IResponseEvents>(
      `@cms/events?filters[dateStart][$lte]=${this.currentDate.toISOString().split('T')[0]}&filters[dateEnd][$gte]=${this.currentDate.toISOString().split('T')[0]}${this.population}`,
    );
  }
}
